//Lib
import React from 'react';
//Styled Component
import { FooterWrapper } from "./styled";
//Const

const Footer = () => {
  return (
    <FooterWrapper>
    </FooterWrapper>
  );
};

export default Footer;